import Customers from '../components/customers/Customers';
import CustomersCreate from '../components/customers/CustomersCreate';
import CustomersEdit from '../components/customers/CustomersEdit';
import CustomersPending from '../components/customers/CustomersPending';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/customers',
  component: Template,
  children: [
    {
      path: '',
      name: 'Customers',
      component: Customers,
      meta: {
        title: 'Customers - Mod24',
      },
    },
    {
      path: 'create',
      name: 'CustomersCreate',
      component: CustomersCreate,
      meta: {
        title: 'Create Customer - Mod24',
      },
    },
    {
      path: 'edit/:id',
      name: 'CustomersEdit',
      component: CustomersEdit,
      meta: {
        title: 'Edit Customer - Mod24',
      },
    },
    {
      path: 'pending',
      name: 'CustomersPending',
      component: CustomersPending,
      meta: {
        title: 'Pending Customers - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/customersRoutes.js